import { createSlice } from '@reduxjs/toolkit'

const alertService = createSlice({
  name: 'alertService',
  initialState: {
    errors: [],
    type: 'error',
    show: false,
  },
  reducers: {
    showErrors(state, action) {
      if (typeof action.payload === 'string') {
        state.errors = [action.payload];
      } else if (Array.isArray(action.payload)) {
        state.errors = action.payload;
      } else if (action.payload.errors) {
        state.errors = action.payload.errors;
      }

      if (action.payload.type) {
        state.type = action.payload.type;
      }
      state.show = true;
    },
    dismissErrors(state) {
      state.errors = [];
      state.show = false;
    },
  },
});

export const {
  showErrors,
  dismissErrors,
} = alertService.actions

export default alertService.reducer;
